import { Profile } from './Profile';
import { User } from './user';

export interface Participant {
  id: number;
  user_id?: number;
  training_id?: number;
  date?: string;
  created_at?: string;
  updated_at?: string;
  created_by?: number;
  updated_by?: number;
  queue?: number;
  queue_automatic?: string;
  special_class?: number;
  box_id?: number;
  start_time?: string;
  end_time?: string;
  user?: User | null;
  [key: string]: any;
}

export function parseParticipant(json: any): Participant {
  if (!json || typeof json !== 'object') {
    return {
      id: 0,
      user_id: undefined,
      training_id: undefined,
      date: undefined,
      created_at: undefined,
      updated_at: undefined,
      created_by: undefined,
      updated_by: undefined,
      queue: undefined,
      queue_automatic: undefined,
      special_class: undefined,
      box_id: undefined,
      start_time: undefined,
      end_time: undefined,
      user: null,
    };
  }

  // helper seguro para parsear número (si no convertible devuelve undefined)
  const toNumber = (v: any): number | undefined => {
    if (v === undefined || v === null || v === '') return undefined;
    const n = Number(v);
    return Number.isNaN(n) ? undefined : n;
  };

  const userRaw = json.user ?? null;

  // Normalizar profile si viene como string (por si acaso)
  let profile: Profile | null = null;
  if (userRaw && typeof userRaw === 'object' && userRaw.profile) {
    profile = {
      user_id: toNumber(userRaw.profile.user_id) ?? toNumber(userRaw.id) ?? 0,
      name: userRaw.profile.name ?? '',
      first_surname: userRaw.profile.first_surname ?? '',
      second_surname: userRaw.profile.second_surname ?? '',
      birthdate: userRaw.profile.birthdate ?? null,
      gender: userRaw.profile.gender ?? null,
      picture: userRaw.profile.picture ?? null,
      pictureUrl: userRaw.profile.pictureUrl ?? userRaw.profile.resizedPictureUrl ?? null,
    };
  }

  const user: User | null = userRaw
    ? {
        id: toNumber(userRaw.id) ?? toNumber(json.user_id) ?? 0,
        username: userRaw.username ?? null,
        email: userRaw.email ?? null,
        profile,
        ...userRaw,
      }
    : null;

  const out: Participant = {
    id: toNumber(json.id) ?? 0,
    user_id: toNumber(json.user_id) ?? undefined,
    training_id: toNumber(json.training_id) ?? undefined,
    date: json.date ?? undefined,
    created_at: json.created_at ?? undefined,
    updated_at: json.updated_at ?? undefined,
    created_by: toNumber(json.created_by) ?? undefined,
    updated_by: toNumber(json.updated_by) ?? undefined,
    queue: toNumber(json.queue) ?? undefined,
    queue_automatic: json.queue_automatic ?? '',
    special_class: toNumber(json.special_class) ?? undefined,
    box_id: toNumber(json.box_id) ?? undefined,
    start_time: json.start_time ?? undefined,
    end_time: json.end_time ?? undefined,
    user,
  };

  return out;
}
